if (!customElements.get('sac-signup-popup')) {
  class SacSignupPopup extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.cleanups = [];
      this.dismissalKey = 'sac-city-welcome-dismissed-until-v1';
      this.subscribedKey = 'sac-city-welcome-subscribed-v1';
      this.cartKey = 'sac-city-welcome-cart-visit-v1';
      this.cartInteracted = this.readStorage('sessionStorage', this.cartKey) === '1';
      const listen = (target, event, callback, options) => {
        target.addEventListener(event, callback, options);
        this.cleanups.push(() => target.removeEventListener(event, callback, options));
      };
      this.rememberDismissal = () => {
        const days = Math.max(1, Number(this.dataset.dismissDays) || 7);
        this.writeStorage('localStorage', this.dismissalKey, String(Date.now() + days * 86400000));
      };
      this.onClose = () => {
        this.rememberDismissal();
        document.documentElement.classList.remove('sac-signup-popup-open');
        if (this.previousFocus?.isConnected && typeof this.previousFocus.focus === 'function') {
          this.previousFocus.focus({ preventScroll: true });
        }
      };
      listen(this.dialog, 'close', this.onClose);
      listen(this.dialog, 'click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      });
      for (const button of this.querySelectorAll('[data-signup-close]')) {
        listen(button, 'click', () => this.dialog.close());
      }
      listen(document, 'click', event => {
        const opener = event.target.closest?.('[data-sac-signup-open]');
        if (!opener) return;
        if (this.open(true, opener)) event.preventDefault();
      });
      const cartInteraction = () => {
        this.cartInteracted = true;
        this.writeStorage('sessionStorage', this.cartKey, '1');
        clearTimeout(this.timer);
      };
      listen(window, 'aftersell-upcart:public-events:cart-opened', cartInteraction);
      for (const event of ['on:cart:add', 'on:line-item:change', 'on:cart-drawer:before-open', 'dispatch:cart-drawer:open']) {
        listen(document, event, cartInteraction);
      }
      listen(document, 'click', event => {
        if (event.target.closest?.('#cart-icon, a[href="/cart"], [name="add"], [data-add-to-cart], .product-form__submit')) cartInteraction();
      }, true);
      listen(document, 'submit', event => {
        if (event.target.matches?.('form[action*="/cart/add"], form[action="/cart"]')) cartInteraction();
      }, true);
      const success = this.querySelector('[data-signup-success]');
      if (success) this.writeStorage('localStorage', this.subscribedKey, '1');
      const parameters = new URLSearchParams(window.location.search);
      const popupResponse = parameters.get('popup_signup') === '1';
      if (popupResponse && (success || this.querySelector('[data-signup-errors]'))) {
        this.open(true);
        return;
      }
      if (this.dataset.designMode === 'true') {
        listen(document, 'shopify:section:select', event => {
          if (event.target.contains(this)) this.open(true);
        });
        listen(document, 'shopify:section:deselect', event => {
          if (event.target.contains(this) && this.dialog.open) this.dialog.close();
        });
        return;
      }
      if (this.readStorage('localStorage', this.subscribedKey) === '1'
        || Number(this.readStorage('localStorage', this.dismissalKey)) > Date.now()
        || this.cartInteracted) return;
      const seconds = Math.max(5, Number(this.dataset.delay) || 10);
      this.timer = setTimeout(() => {
        if (!this.cartInteracted && !this.busy()) this.open();
      }, seconds * 1000);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.dialog?.open) this.dialog.close();
      this.cleanups?.forEach(cleanup => cleanup());
      this.cleanups = [];
      document.documentElement.classList.remove('sac-signup-popup-open');
    }

    readStorage(storage, key) {
      try { return window[storage].getItem(key); } catch { return null; }
    }

    writeStorage(storage, key, value) {
      try { window[storage].setItem(key, value); } catch {}
    }

    busy() {
      if (document.hidden) return true;
      if (document.querySelector('.sac-header__search[open], .sac-header__mobile[open], dialog[open], modal-dialog[open], pop-up[open], [aria-hidden="false"].drawer')) return true;
      if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return true;
      return [...document.querySelectorAll('[role="dialog"][aria-modal="true"]')].some(element => {
        if (this.contains(element) || element.closest('[hidden], [aria-hidden="true"]')) return false;
        const style = getComputedStyle(element);
        return element.getClientRects().length > 0 && style.display !== 'none' && style.visibility !== 'hidden';
      });
    }

    open(manual = false, opener) {
      if (this.dialog.open) return true;
      if (!manual && (this.cartInteracted || this.busy())) return false;
      if (manual && document.querySelector('dialog[open], modal-dialog[open], pop-up[open]')) return false;
      clearTimeout(this.timer);
      this.previousFocus = opener || document.activeElement;
      this.dialog.showModal();
      document.documentElement.classList.add('sac-signup-popup-open');
      this.rememberDismissal();
      const response = this.querySelector('[data-signup-success], [data-signup-errors]');
      if (response) response.focus({ preventScroll: true });
      else this.querySelector('input[type="email"]')?.focus({ preventScroll: true });
      return true;
    }
  }
  customElements.define('sac-signup-popup', SacSignupPopup);
}
